import React from 'react'

import { reverse } from 'named-urls'

import { Paper, Typography, Box, Divider, Button } from '@material-ui/core'

import SettingsAccountTable from './components/SettingsAccountTable'
import SettingsAccountForm from './components/SettingsAccountForm'

import { routes } from 'routes'
import { Permitted } from 'components/Permissions'
import { LogButton } from 'components/Logs'
import * as service from 'service'
import helpers from 'helpers'
import useAuth from 'hooks/useAuth'
import useSnackbar from 'hooks/useSnackbar'

const AccountMain = () => {
  const snackbar = useSnackbar()
  const auth = useAuth()
  const sellerId = 1
  const [edit, setEdit] = React.useState(false)
  const [isLoading, setLoading] = React.useState(true)
  const [seller, setSeller] = React.useState({})
  const [logo, setLogo] = React.useState()

  React.useEffect(() => {
    setLoading(true)

    const loadSeller = async () => {
      const response = await service.recurrence.sellers.get({ sellerId })
      setSeller(response.data.seller)
      return response.data.seller
    }

    loadSeller().finally(() => setLoading(false))
  }, [])

  const handleChangeLogo = (event, file) => {
    setLogo(file)
  }

  const onSubmit = async data => {
    setLoading(true)

    const formData = new FormData()
    formData.append('file', logo)

    try {
      const [responseSeller, responseLogo] = await Promise.all([
        service.recurrence.sellers.update({
          sellerId,
          ...data,
          contactAttributes: helpers.people.convertPhoneApi(data.phone),
        }),
        ...(logo
          ? [service.recurrence.sellers.logo({ sellerId, formData })]
          : []),
      ])

      await auth.loadData()

      snackbar.open({
        message: 'Informações da conta alteradas com sucesso!',
        variant: 'success',
      })

      const newLogo = responseLogo
        ? responseLogo.data.seller.logo
        : responseSeller.data.seller.logo

      const seller = {
        ...responseSeller.data.seller,
        logo: newLogo,
      }

      setSeller(seller)
      setLogo(undefined)
      setLoading(false)
      setEdit(false)
    } catch (error) {
      const message =
        error &&
        error.response &&
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.message

      snackbar.open({
        message: `Erro ao alterar informações da conta! ${message}`,
        variant: 'error',
      })

      setLoading(false)
      setEdit(false)
    }
  }

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">Informações da conta</Typography>
        <Box display="flex">
          <LogButton
            variant="outlined"
            color="primary"
            to={reverse(routes.settings.account.logs, {
              sellerId,
            })}
          />

          <Permitted tag="update_seller">
            {!edit ? (
              <Box ml={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setEdit(true)}
                >
                  Editar
                </Button>
              </Box>
            ) : null}
          </Permitted>
        </Box>
      </Box>
      <Divider />

      {edit && !isLoading ? (
        <SettingsAccountForm
          seller={seller}
          handleClose={setEdit}
          onChangeLogo={handleChangeLogo}
          onSubmit={onSubmit}
        />
      ) : (
        <SettingsAccountTable
          seller={seller}
          isLoading={isLoading}
          setEdit={setEdit}
        />
      )}
    </Paper>
  )
}

export default AccountMain
